import { Component } from '@angular/core';
import { RoutesUtilsService } from '@vfde-fe/ngx-lib/services/routes-utils';
import { CustomErrorHandlerService } from '@vfde-fe/ngx-lib/services/custom-error-handler';
import { Navigation } from '@vfde-fe/ngx-lib/models/navigation';
import { LARGE_ICON, RED_WARNING_ICON } from 'src/app/shared/defines/defines';

/** componet */
@Component({
  selector: 'app-general-error',
  templateUrl: './general-error.component.html',
  styleUrls: ['./general-error.component.css'],
})
export class GeneralErrorComponent {
    /** error */
    public error;
    /** title */
    public title = '';
    /** accessLevel */
    public accessLevel = null;
    /** navigationDetails */
    public navigationDetails: Navigation;

    public constructor (private customErrorHandlerService: CustomErrorHandlerService, private routesUtilsService: RoutesUtilsService) {
        const data = this.customErrorHandlerService.getCurrentError();
        this.title = data.title;
        this.accessLevel = data.accessLevel;
        this.error = data.error;
        this.error = {...this.error, iconName: RED_WARNING_ICON, iconSize: LARGE_ICON};
    }
  }
